import React from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Plus, Pencil, Trash2, Loader2 } from 'lucide-react';

export function AdminHeader({ title, description, onCreate, createLabel = 'New', createTestId }) {
  return (
    <div className="flex items-start justify-between mb-3">
      <div>
        <h2 className="font-heading text-lg font-bold text-stone-900">{title}</h2>
        {description && <p className="text-xs text-stone-500">{description}</p>}
      </div>
      {onCreate && (
        <Button
          size="sm"
          onClick={onCreate}
          className="h-8 bg-stone-900 hover:bg-stone-800 text-white"
          data-testid={createTestId}
        >
          <Plus className="w-4 h-4 mr-1" /> {createLabel}
        </Button>
      )}
    </div>
  );
}

export function AdminTable({ columns, rows, onEdit, onDelete, rowTestId, loading }) {
  if (loading) {
    return (
      <div className="p-8 text-center text-stone-400">
        <Loader2 className="w-6 h-6 animate-spin mx-auto" />
      </div>
    );
  }
  if (!rows || rows.length === 0) {
    return (
      <Card className="p-6 text-center text-sm text-stone-500 border-stone-200">
        No entries yet. Create the first one to get started.
      </Card>
    );
  }
  return (
    <Card className="overflow-hidden border-stone-200">
      <table className="w-full text-sm">
        <thead className="bg-stone-50 border-b border-stone-200">
          <tr>
            {columns.map((c) => (
              <th key={c.key} className="text-left px-3 py-2 text-[10px] uppercase tracking-widest text-stone-500 font-semibold">
                {c.label}
              </th>
            ))}
            <th className="w-24"></th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr
              key={r.id}
              data-testid={rowTestId ? rowTestId(r.id) : undefined}
              className="border-b border-stone-100 hover:bg-stone-50"
            >
              {columns.map((c) => (
                <td key={c.key} className="px-3 py-2 align-top">
                  {c.render ? c.render(r) : r[c.key] || <span className="text-stone-400">—</span>}
                </td>
              ))}
              <td className="px-2 py-1 text-right">
                {onEdit && (
                  <Button variant="ghost" size="icon" onClick={() => onEdit(r)} className="h-7 w-7">
                    <Pencil className="w-3.5 h-3.5" />
                  </Button>
                )}
                {onDelete && (
                  <Button
                    variant="ghost" size="icon" onClick={() => onDelete(r)}
                    className="h-7 w-7 text-red-600 hover:text-red-700 hover:bg-red-50"
                    data-testid={`admin-delete-${r.id}`}
                  >
                    <Trash2 className="w-3.5 h-3.5" />
                  </Button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Card>
  );
}
